import ClickCollectSubmitConnector from './clickCollectSubmit.props';
import ClickCollectSubmitComponent from './clickCollectSubmit.component';

export default ClickCollectSubmitConnector(ClickCollectSubmitComponent);
